module.exports = __webpack_public_path__ + "static/media/undraw_word_of_mouth_v1j9.0bce1547.svg";